import { orchestrator } from 'satcheljs';
import { onFolderClickedInMoveToControlAction } from 'owa-mail-moveto-control';
import { resetFocus } from '../mailModuleAutoFocusManager';

export default <
    (actionMessage: ReturnType<typeof onFolderClickedInMoveToControlAction>) => void | Promise<void>
>orchestrator(onFolderClickedInMoveToControlAction, () => {
    resetFocus('FolderClickMoveToControl');
});
